// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2YN3l","inputWrap":"CustomTip_inputWrap__oz7j3"};